import { Deserializer, DeserializerOptions } from 'jsonapi-serializer';
import { Document } from 'jsonapi-typescript';
import { Observable } from 'rxjs';
import { MetaNew } from '../interfaces/meta-new.interface';
import { UserVehicleAssignment } from '../interfaces/user-vehicle-assignment.interface';

const assignmentDeserializer = new Deserializer({
	keyForAttribute: 'snake_case',
	typeAsAttribute: true,
	Vehicle: {
		valueForRelationship: (relationship: { id: string }) => ({ id: relationship.id }),
	},
} as DeserializerOptions);

export function deserializeUserVehicleAssignments(
	document: Document
): Observable<{ assignments: UserVehicleAssignment[]; meta: MetaNew }> {
	return new Observable((observer) => {
		assignmentDeserializer.deserialize(document, (err: Error, response: any) => {
			if (err) {
				observer.error(err);
			} else {
				const data: any[] = Array.isArray(response) ? response : [response];
				observer.next({ assignments: data, meta: (document as any)?.meta });
				observer.complete();
			}
		});
	});
}
